const accountInitialState = {
    detachConfirmed: false,
    disableEditAccountButton: false,
    editAccountFail: false,
    editAccountSuccess: false,
    email: "",
    emailExists: false,
    emailOrPhoneAlreadyTaken: false,
    emailState: "",
    language: "",
    languageState: "",
    name: "",
    nameState: "",
    phone: "",
    phoneState: "",
    steps: [],
    wasFetchedVisibleSystems: false,
    askedAccountId: undefined,
    account: null,
    unregisterFromMobileAppConfirmed: false,
    accountFilteredSystems: [],
    accountFilteredSystemsNames: [],
    isAccountFilteredSystemNameUpdated: false,
    isAccountSystemSearchBarVisible: true
}

export default accountInitialState;